import { render } from "./ThemeButton.vue?vue&type=template&id=656fb0d8&scoped=true"
import script from "./ThemeButton.vue?vue&type=script&lang=js"
export * from "./ThemeButton.vue?vue&type=script&lang=js"

import "./ThemeButton.vue?vue&type=style&index=0&id=656fb0d8&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/goatsd.com_VUE.js_main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656fb0d8"]])

export default __exports__